/**
 * Created by hj on 2017/9/12.
 */
import {config, request} from 'Utils';

/**
 * 订单列表
 * @param param
 * @returns {*}
 */
export function getReturnOrderList(param) {
  return request(`${config.server}/api/v1/dms/orderReturn/list`, {
    method: 'post',
    body: param
  });
}

/**
 * 订单详情
 * @param param
 * @returns {*}
 */
export function getReturnOrderDetails(id) {
  return request(`${config.server}/api/v1/dms/orderReturn/detail?id=${id}`, {
    method: 'get'
  });
}

/**
 * 订单审核
 * @param param
 * @returns {*}
 */
export function returnOrderApprove(param) {
  return request(`${config.server}/api/v1/dms/orderReturn/audit`, {
    method: 'post',
    body: param
  });
}

/**
 * 确认收货
 * @param param
 * @returns {*}
 */
export function returnOrderConfirmCollect(param) {
  return request(`${config.server}/api/v1/dms/orderReturn/updateReceived`, {
    method: 'post',
    body: param
  });
}

/**
 * 获取发货单初始数据
 * @param param
 * @returns {*}
 */
export function getSendProduct(orderId) {
  return request(`${config.server}/api/v1/dms/orderReturn/productStorage?id=${orderId}`, {
    method: 'get'
  });
}
/**
 * 品牌商 新建发货单
 * @param param
 * @returns {*}
 */
export function returnOrderSendSave(param) {
  return request(`${config.server}/api/v1/dms/orderReturn/updateDeliveryBrand`, {
    method: 'post',
    body: param
  });
}

/**
 * 品牌商 确认退款
 * @param param
 * @returns {*}
 */
export function returnOrderConfirmAmount(param) {
  return request(`${config.server}/api/v1/dms/orderReturn/confirmReturnPay`, {
    method: 'post',
    body: param
  });
}

/**
 * 品牌商 仓库-货位
 * @param param
 * @returns {*}
 */
export function getWarehouseList() {
  return request(`${config.server}/api/v1/dms/storage/listTreeBrand`, {
    method: 'get'
  });
}


/******************* 商品选型库 start *********************/
/**
 * 退换货列表
 * @param param
 * @returns {*}
 */
export function orderReturnList(param) {
  return request(`${config.server}/api/v1/orderReturn/listByApp`, {
    method: 'post',
    body: param
  });
}

/**
 * 取消（针对退换货单）
 * @param param
 * {
 *    id, //退换货单的ID
 * }
 * @returns {*}
 */
export function cancelReturnOrder(param) {
  return request(`${config.server}/api/v1/orderReturn/cancel`, {
    method: 'post',
    body: param
  });
}
/******************* 商品选型库 end *********************/



// WEBPACK FOOTER //
// ./src/service/returnOrder/index.js